import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { takeWhile } from 'rxjs/operators';
import { PassengersSegmentedCount } from '@ibe/models';
import * as fromStore from '@ibe/store/index';
import * as MiniIBEActions from '@ibe/store/actions/mini-ibe.actions';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SidebarService } from '@ibe.components/common/sidebar/sidebar.service';
import * as BookingTripAction from '@ibe/store/actions/booked-trip.actions';

@Component({
	selector: 'app-edit-passengers',
	templateUrl: './edit-passengers.component.html',
	styleUrls: ['./edit-passengers.component.scss']
})
export class EditPassengersComponent implements OnInit {

	isAlive = true;
	form: FormGroup;
	count: number;

	passengers$: Observable<PassengersSegmentedCount> = this.store.select(fromStore.getMiniIBEPassengers);
	passengers: PassengersSegmentedCount;

	constructor(
		private store: Store<fromStore.State>,
		private fb: FormBuilder,
		protected sidebarService: SidebarService
	) {
		this.count = 9;
		this.passengers$.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value) {
					this.passengers = value;
				}
			});
	}

	ngOnInit() {
		this.form = this.fb.group({
			adults: [this.passengers.adults, Validators.required],
			youngAdults: [this.passengers.youngAdults, Validators.required],
			children: [this.passengers.children, Validators.required],
			infants: [this.passengers.infants, Validators.required]
		});
		this.onChanges();
	}

	onChanges(): void {
		this.form.valueChanges.subscribe(val => {
			const total = 9 - (parseInt(val['adults'], 10) + parseInt(val['youngAdults'], 10) + parseInt(val['children'], 10) + parseInt(val['infants'], 10));
			if (total > 0)
				this.count = 9;
			else
				this.count = 0;
		});

	}

	TAP_saveSidebar() {
		const passengers = Object.assign({}, {
			children: this.form.controls['children'].value,
			adults: this.form.controls['adults'].value,
			youngAdults: this.form.controls['youngAdults'].value,
			infants: this.form.controls['infants'].value
		});
		// this.store.dispatch(new BookingTripAction.PutBookedTripPassengerAction(passengers));
		this.store.dispatch(new MiniIBEActions.PutPassengers(passengers));
		this.store.dispatch(new BookingTripAction.PutBookedTripPassengerAction(passengers));
		this.sidebarService.previousSidebar();
	}

	// SIDEBAR INTERACTIONS

	/** Close sidebar and clear secondary route */
	private closeSidebar() {
		this.sidebarService.closeSidebar();
		// this.router.navigate([{ outlets: { sidebar: null } }]);
	}

	/** Handles close action intention **/
	TAP_handleClose() {
		this.closeSidebar();
	}
}
